<template>
  <div>
    <v-overlay
      v-if="local_modal && $store.state.hasMotors"
      opacity="1"
      color="#A69578"
      style="text-align=center"
    >
      <!--  &&
          !this.$store.state.nextEnabled2 -->
      <v-progress-circular indeterminate color="red"></v-progress-circular
      ><br /><strong style="color: red">{{
        $t("keyDrop.wait")
      }}</strong></v-overlay
    >
    <v-container style="height: 70%" align-center justify-center>
      <v-row>
        <v-col cols="3" />
        <v-col cols="6">{{ $t("keyDrop.title") }}</v-col>
        <v-col cols="3" />
      </v-row>

      <v-row>
        <v-col cols="3" />
        <!-- eslint-disable vue/no-v-html -->
        <v-col cols="6"><p v-html="$t('keyDrop.papers')" /></v-col>
        <!-- eslint-enable -->
        <v-col cols="3" />
      </v-row>
      <v-row>
        <v-col cols="2" />
        <v-col cols="1"
          ><v-switch
            v-model="confirmKey"
            @click="toggleKey"
            @change="toggleKey"
        /></v-col>
        <v-col cols="7" style="padding: 30px 12px 0 12px">{{
          $t("keyDrop.confirmKey")
        }}</v-col>
        <v-col cols="2" />
      </v-row>
      <v-row>
        <v-col cols="2" />
        <v-col cols="1"
          ><v-switch
            v-model="confirmPaper"
            @click="togglePaper"
            @change="togglePaper"
        /></v-col>
        <v-col cols="7" style="padding: 30px 12px 0 12px">{{
          $t("keyDrop.confirmPaper")
        }}</v-col>
        <v-col cols="2" />
      </v-row>
      <v-row>
        <v-col cols="2" />
        <v-col cols="1"
          ><v-switch
            v-model="restitutionWish"
            @click="toggleRestitutionWish"
            @change="toggleRestitutionWish"
        /></v-col>
        <v-col cols="7" style="padding: 30px 12px 0 12px">{{
          $t("keyDrop.restitutionWish")
        }}</v-col>
        <v-col cols="2" />
      </v-row>
      <v-row v-if="!$store.state.hasMotors">
        <v-col cols="2" />
        <v-col cols="1"
          ><v-switch
            v-model="closeLocker"
            @click="toggleCloseLocker"
            @change="toggleCloseLocker"
        /></v-col>
        <v-col cols="7" style="padding: 30px 12px 0 12px">{{
          $t("keyDrop.closeLocker")
        }}</v-col>
        <v-col cols="2" />
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "KeyDrop",

  data() {
    return {
      confirmKey: false,
      confirmPaper: false,
      restitutionWish: false,
      closeLocker: false,
      local_modal: true,
    };
  },
  beforeMount() {
    if (this.confirmKey) {
      this.$store.commit("enableNext");
    } else {
      this.$store.commit("disableNext");
    }
  },
  mounted() {
    if (this.$store.state.apptId == 0) this.$router.push("/");
    window.setTimeout(() => {
      this.local_modal = false;
    }, 5000);
  },
  methods: {
    toggleKey() {
      if (this.confirmKey) {
        this.$store.commit("keyDropKey");
        if (
          this.confirmKey &&
          (this.$store.state.hasMotors || this.closeLocker)
        ) {
          this.$store.commit("enableNext");
        }
      } else {
        this.$store.commit("keyDropNotKey");
        this.$store.commit("disableNext");
      }
      let cb_conf = this.$store.state.callback;
      if (this.$store.state.hasMotors) axios.get("http://localhost:3000/front");
      else {
        if (this.$store.state.timeout !== "not yet")
          window.clearTimeout(this.$store.state.timeout);
        let timeout = window.setTimeout(() => {
          window.location.href = cb_conf;
        }, process.env.VUE_APP_NOMOTOR_TIMEOUT);
        this.$store.commit({ type: "timeout", timeout: timeout });
      }
    },
    togglePaper() {
      if (this.confirmPaper) {
        this.$store.commit("keyDropPaper");
      } else {
        this.$store.commit("keyDropNotPaper");
      }
      if (
        this.confirmKey &&
        (this.$store.state.hasMotors || this.closeLocker)
      ) {
        this.$store.commit("enableNext");
      } else {
        this.$store.commit("disableNext");
      }

      let cb_conf = this.$store.state.callback;
      if (this.$store.state.hasMotors) axios.get("http://localhost:3000/front");
      else {
        if (this.$store.state.timeout !== "not yet")
          window.clearTimeout(this.$store.state.timeout);
        let timeout = window.setTimeout(() => {
          window.location.href = cb_conf;
        }, process.env.VUE_APP_NOMOTOR_TIMEOUT);
        this.$store.commit({ type: "timeout", timeout: timeout });
      }
    },
    toggleRestitutionWish() {
      if (this.restitutionWish) {
        this.$store.commit("keyDropRestitution");
      } else {
        this.$store.commit("keyDropNotRestitution");
      }
      if (
        this.confirmKey &&
        (this.$store.state.hasMotors || this.closeLocker)
      ) {
        this.$store.commit("enableNext");
      } else {
        this.$store.commit("disableNext");
      }
      let cb_conf = this.$store.state.callback;
      if (this.$store.state.hasMotors) axios.get("http://localhost:3000/front");
      else {
        if (this.$store.state.timeout !== "not yet")
          window.clearTimeout(this.$store.state.timeout);
        let timeout = window.setTimeout(() => {
          window.location.href = cb_conf;
        }, process.env.VUE_APP_NOMOTOR_TIMEOUT);
        this.$store.commit({ type: "timeout", timeout: timeout });
      }
    },
    toggleCloseLocker() {
      let cb_conf = this.$store.state.callback;
      if (this.$store.state.hasMotors) axios.get("http://localhost:3000/front");
      else {
        if (this.$store.state.timeout !== "not yet")
          window.clearTimeout(this.$store.state.timeout);
        let timeout = window.setTimeout(() => {
          window.location.href = cb_conf;
        }, process.env.VUE_APP_NOMOTOR_TIMEOUT);
        this.$store.commit({ type: "timeout", timeout: timeout });
      }
      if (!this.$store.state.hasMotors) {
        let st = this.$store;
        axios
          .get(
            process.env.VUE_APP_API_BASE +
              "/doorstatus/" +
              this.$store.state.apptId
          )
          .then((resp) => {
            if (resp.data.status != "LOCKED") {
              this.closeLocker = false;
              st.commit("disableNext");
            } else {
              if (this.confirmKey) {
                st.commit("enableNext");
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.closeLocker = false;
            st.commit("disableNext");
          });
      }
    },
  },
};
</script>
